module.exports = __webpack_public_path__ + "components/MapControl/svg/Stadnina koni.svg?0e271b25";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Stadnina koni.svg
// module id = 2043
// module chunks = 0